///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const PictureIcon = ({
  height,
  fill,
  title = messages.picture.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    aria-labelledby="picture-icon"
    height={height}
    viewBox="0 0 20 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title data-testid="picture-icon">{title}</title>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M16.2,22 L1.8,22 C0.81,22 0,21.2016129 0,20.2258065 L0,1.77419355 C0,0.798387097 0.81,0 1.8,0 L9.126,0 C9.612,0 10.062,0.177419355 10.404,0.514516129 L17.478,7.48709677 C17.82,7.82419355 18,8.26774194 18,8.74677419 L18,20.2258065 C18,21.2016129 17.19,22 16.2,22 Z M1.8,0.709677419 C1.206,0.709677419 0.72,1.18870968 0.72,1.77419355 L0.72,20.2258065 C0.72,20.8112903 1.206,21.2903226 1.8,21.2903226 L16.2,21.2903226 C16.794,21.2903226 17.28,20.8112903 17.28,20.2258065 L17.28,8.74677419 C17.28,8.46290323 17.172,8.19677419 16.956,8.0016129 L9.882,1.02903226 C9.684,0.816129032 9.414,0.709677419 9.126,0.709677419 L1.8,0.709677419 Z"
      id="Shape"
      stroke={fill}
    />
    <path
      d="M8.64,16.6774194 C8.406,16.6774194 8.172,16.6064516 7.974,16.4645161 L4.194,13.5725806 C4.068,13.466129 3.888,13.466129 3.744,13.5725806 L0.594,16.0564516 L0.144,15.5064516 L3.294,13.0225806 C3.69,12.7209677 4.23,12.7032258 4.626,13.0048387 L8.424,15.8790323 C8.55,15.9677419 8.73,15.9854839 8.856,15.8790323 L13.248,12.5967742 C13.608,12.3306452 14.094,12.3129032 14.472,12.5435484 L17.838,14.6016129 L17.46,15.2048387 L14.094,13.1467742 C13.968,13.0758065 13.806,13.0758065 13.68,13.1645161 L9.288,16.4467742 C9.108,16.6064516 8.874,16.6774194 8.64,16.6774194 Z"
      id="Path"
      fill={fill}
    ></path>
    <path
      d="M7.02,9.93548387 C5.724,9.93548387 4.68,8.90645161 4.68,7.62903226 C4.68,6.3516129 5.724,5.32258065 7.02,5.32258065 C8.316,5.32258065 9.36,6.3516129 9.36,7.62903226 C9.36,8.90645161 8.316,9.93548387 7.02,9.93548387 Z M7.02,6.03225806 C6.12,6.03225806 5.4,6.74193548 5.4,7.62903226 C5.4,8.51612903 6.12,9.22580645 7.02,9.22580645 C7.92,9.22580645 8.64,8.51612903 8.64,7.62903226 C8.64,6.74193548 7.92,6.03225806 7.02,6.03225806 Z"
      id="Shape"
      fill={fill}
    ></path>
  </svg>
);

export default PictureIcon;
